import { theme } from '@prophecy/theme';
import { hexToRGBA } from '@prophecy/theme/utils';

export const tokens = {
  Spinner: {
    Overlay: {
      backgroundColor: hexToRGBA(theme.colors.white, 0.6),
      zIndex: theme.zLayer.s
    },
    Tip: {
      fontSize: {
        sm: theme.text.sm.fontSize,
        lg: theme.text.lg.fontSize
      }
    },
    loaderSize: {
      xs: theme.sizes.x16,
      s: theme.sizes.x20,
      m: theme.sizes.x24,
      l: theme.sizes.x28,
      xl: theme.sizes.x32
    },
    gap: theme.spaces.x8
  },
  OverlaySpinner: {
    zIndex: theme.zLayer.xxl
  }
};
